import React, { useContext } from "react";

const ThemeContext = React.createContext("light");
export { ThemeContext };

const Colors = {
  dark: {
    headerBackground: "rgb(255, 255, 255)",
    listTitleColor: "rgb(38,208,124)",
    background: "#303030",
    divider: "#595959",
    detail: "#d3d3d3",
    infoButton: "#dd3c31",
    images: {
      ergo: "./images/ergo_dark.png",
      radix: "./images/radix.png",
      apple: "./images/apple_dark.png",
      android: "./images/android.png",
      web: "./images/web_dark.png",
      windows: "./images/windows.png",
      logo: "./images/infominds_dark.png",
      appStore: "./images/appStore.png",
      googlePlay: "./images/googlePlay.png",
    },
    textColor: "#fff",
    switchButton: "#000",
    selectedColor: "rgb(38,208,124)",
    buttonBackgroundColor: "#303030",
    selectedBorderWidth: 3,
  },
  light: {
    headerBackground: "rgb(255, 255, 255)",
    listTitleColor: "rgb(38,208,124)",
    background: "#fafafa",
    divider: "#e0e0e0",
    detail: "#8e8e8e",
    infoButton: "#dd3c31",
    images: {
      ergo: "./images/ergo_light.png",
      radix: "./images/radix.png",
      apple: "./images/apple_light.png",
      android: "./images/android.png",
      web: "./images/web_light.png",
      windows: "./images/windows.png",
      logo: "./images/infominds_light.png",
      appStore: "./images/appStore.png",
      googlePlay: "./images/googlePlay.png",
    },
    textColor: "#000",
    switchButton: "rgb(214, 214, 214)",
    selectedColor: "rgb(38,208,124)",
    buttonBackgroundColor: "rgb(255, 255, 255)",
    selectedBorderWidth: 3,
  },
};

export default function useTheme() {
  const theme = useContext(ThemeContext);
  // @ts-ignore
  return Colors[theme];
}
